import { Tooltips } from './tooltip';

const ActionIcon = ({ onClick, children, color, position, content, command }) => {
  // Check if both position and content are provided
  const shouldRenderTooltip = position && content;

  return (
    <>
      {shouldRenderTooltip ? (
        <Tooltips position={position} content={content} command={command}>
          <div onClick={onClick} className={`${color} cursor-pointer`}>
            {children}
          </div>
        </Tooltips>
      ) : (
        <div onClick={onClick} className={`${color} cursor-pointer`}>
          {children}
        </div>
      )}
    </>
  );
};

export default ActionIcon;
